import { OrderFeedbackType } from '../../../types/OrderFeedbackType';
import { ActionType } from '../../../types/ActionType';
import { OrderStateType } from '../../../types/OrderStateType';
import { OrderType } from '../../../types/OrderType';
import ActionsCorner from './ActionsCorner/ActionsCorner';
import './BodyDetails.scss';
import OrderDetails from './OrderDetails/OrderDetails';
import PaymentMethodDetails from './PaymentMethodDetails/PaymentMethodDetails';
import { useState, useEffect } from 'react';
import ResponsiveBodyDetails from './ResponsiveBodyDetails';
import { WalletDetails } from 'models/WalletDetails';
import { OrderSource } from 'pages/OrderLifeCycle/types/OrderSource';

type BodyDetailsProps = {
	unitPrice: string;
	quantity: string;
	amount: string;
	feedback: OrderFeedbackType;
	paymentMehodId: number;
	accountNNumber: string;
	orderState: OrderStateType;
	orderNumber: string;
	actions: ActionType[];
	orderType: OrderType;
	merchantId: string;
	userName: string;
	note: string;
	canReview: boolean;
	isActionsHidden: boolean;
	triggerAction: (action: ActionType, reasons?: string, otp?: string) => void;
	getOrderDetails: () => void;
	paymentProof: boolean;
	paymentProofFileId: string;
	paymentProofFileLabel: string;
	otpVlaid: { value: boolean };
	loading: boolean;
	accountGroup: string;
	walletDetails: WalletDetails;
	source: OrderSource;
};

function BodyDetails({
	orderState,
	unitPrice,
	quantity,
	amount,
	feedback,
	paymentMehodId,
	accountNNumber,
	accountGroup,
	orderNumber,
	actions,
	orderType,
	merchantId,
	userName,
	note,
	isActionsHidden,
	canReview,
	triggerAction,
	getOrderDetails,
	paymentProof,
	paymentProofFileId,
	paymentProofFileLabel,
	otpVlaid,
	loading,
	walletDetails,
	source,
}: BodyDetailsProps) {
	const [windowWidth, setWindowWidth] = useState(window.innerWidth);

	useEffect(() => {
		const handleResize = () => {
			setWindowWidth(window.innerWidth);
		};

		window.addEventListener('resize', handleResize);

		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);
	return (
		<div className='body-details-wrapper'>
			{windowWidth >= 500 && (
				<>
					<OrderDetails
						unitPrice={unitPrice}
						quantity={quantity}
						amount={amount}
						note={note}
						orderNumber={orderNumber}
						source={source}
					/>
					<PaymentMethodDetails
						paymentMehodId={paymentMehodId}
						accountNNumber={accountNNumber}
						accountGroup={accountGroup}
						amount={amount}
						orderType={orderType}
						paymentProof={paymentProof}
						paymentProofFileId={paymentProofFileId}
						paymentProofFileLabel={paymentProofFileLabel}
						orderNumber={orderNumber}
						walletDetails={walletDetails}
						source={source}
					/>
				</>
			)}
			{windowWidth < 500 && (
				<ResponsiveBodyDetails
					unitPrice={unitPrice}
					quantity={quantity}
					note={note}
					paymentMehodId={paymentMehodId}
					accountNumber={accountNNumber}
					accountGroup={accountGroup}
					amount={amount}
					orderType={orderType}
					paymentProof={paymentProof}
					paymentProofFileId={paymentProofFileId}
					paymentProofFileLabel={paymentProofFileLabel}
					orderNumber={orderNumber}
					walletDetails={walletDetails}
					source={source}
				/>
			)}
			{isActionsHidden ? null : (
				<ActionsCorner
					orderState={orderState}
					orderType={orderType}
					feedback={feedback}
					actions={actions}
					orderNumber={orderNumber}
					merchantId={merchantId}
					quantity={quantity}
					amount={amount}
					userName={userName}
					canReview={canReview}
					triggerAction={triggerAction}
					getOrderDetails={getOrderDetails}
					otpVlaid={otpVlaid}
					loading={loading}
				/>
			)}
		</div>
	);
}

export default BodyDetails;
